import {Component, OnInit} from '@angular/core';
import {NgxExtendedPdfViewerService} from 'ngx-extended-pdf-viewer';
import {saveAs} from 'file-saver-es';
import {format} from 'date-fns';

// example page: https://pdfviewer.net/extended-pdf-viewer/getting-started

@Component({
  selector: 'ims-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.less']
})
export class PdfViewerComponent implements OnInit {

  constructor(private svr: NgxExtendedPdfViewerService) {
  }

  ngOnInit(): void {
  }

  doSave(): void {
    console.log('save');
  }

  public async export(): Promise<void> {
    const blob = await this.svr.getCurrentDocumentAsBlob();
    saveAs(blob, `${format(new Date(), 'yyyy-MM-dd_hh-mm-ss')}.pdf`);
  }


}
